<div class="lg:w-[27rem] w-full lg:pb-4 lg:pt-6 lg:px-4 px-5 pt-4 pb-2">
    <h3 *ngIf="data.headerMessage" class="dialog-title-section break-words">
        {{ data.headerMessage }}
    </h3>
    <mat-dialog-content
        class="text-center text-[#5F5B5B] font-medium !pt-0 text-re"
        [innerHTML]="data.message || '' | translate"></mat-dialog-content>
    <mat-dialog-actions align="center" class="dialog-footer-section flex justify-center items-center !mt-2">
        <button
            *ngIf="data.type === PopupType.Confirm"
            type="button"
            mat-dialog-close
            class="btn-cancel border-[#A3A3A3] bg-transparent text-[#5F5B5B] border-[1px]"
            [ngClass]="data.cancelClass">
            {{ data.cancelLabel || 'button.cancel' | translate }}
        </button>
        <button
            type="button"
            cdkFocusInitial
            [mat-dialog-close]="true"
            [ngClass]="{
                'btn-primary': !data.okClass && data.type !== PopupType.Alert,
                'btn-warning': data.type === PopupType.Alert,
            }">
            @let okLabel = data.type === PopupType.Confirm ? 'text.yes' : 'text.ok';

            {{ data.okLabel || okLabel | translate }}
        </button>
    </mat-dialog-actions>
</div>
